import React, { useEffect, useState } from "react";
import icons from "../../../Assets/Icons/pick_2.png";
import MediaPicker from "../mediaPicker";
import toast from "react-hot-toast";
import apiRequest from "../../../apiCall";
import { fileUpload } from "../../../fileUpload";
import config from '../../Config.json'
import { useDispatch } from "react-redux";
import { setLoading } from "../../../Redux/action";
const DescImages = ({ autoComplete, onValueChange }) => {
  const storedData = localStorage.getItem("adminData") || " {}";
  const adminData = JSON.parse(storedData);
  const AdminId = adminData.AdminId || null;

  const [data, setData] = useState({});
  const _data = data;

  const updateData = () => {
    setData((data) => ({
      ...data,
      ..._data,
    }));
  };

  const dispatch = useDispatch();

  const handleSave = async () => {
    dispatch(setLoading(true));
    const uploadImages = data.slider.filter(
      (x) => x.status === "updated" && x.file != null
    );
    const uploadedImages = data.slider.filter((x) => x.status == null);
    if (uploadImages.length > 0) {
      fileUpload(uploadImages).then((uploadImageRes) => {
        if (uploadImageRes?.length > 0) {
          const newUploadedImages = [
            ...uploadedImages.map((x) => x.imageName),
            ...uploadImageRes.map((x) => x.key),
          ];
          saveData(newUploadedImages);
        }
      });
    } else {
      saveData([...uploadedImages.map((x) => x.imageName)]);
    }
  };

  const saveData = (uploadedImages) => {
    if (uploadedImages.length == 0) {
      dispatch(setLoading(false));
      toast.error("Please fill the all values" );
      return;
    }

    const params = {
      itemId: JSON.parse(sessionStorage.getItem("shopApi")).itemId,
      productCode: JSON.parse(sessionStorage.getItem("shopApi")).productCode,
      images: uploadedImages,
      AdminId: AdminId,
    };

    apiRequest("POST", "shop/sectionD", params, true, true).then((res) => {
      dispatch(setLoading(false));
      toast.success( "Data saved successfully" );
      onValueChange(JSON.parse(sessionStorage.getItem("shopApi")).productCode);
      // onChange(JSON.parse(sessionStorage.getItem("shopApi")).productCode);
    });
  };

  useEffect(() => {
    if (autoComplete) {
      const secDData = JSON.parse(sessionStorage.getItem("shopApi")).sectionD;
      _data.slider =
        secDData && secDData.length > 0
          ? secDData?.map((x) => {
              return { image: config.awsMediaPath + x, imageName: x };
            })
          : [];
      updateData();
    } else {
      _data.slider = [];
      updateData();
    }
  }, [autoComplete]);

  return (
    <div className="sec slider">
      <h2>Images for ProductDetails</h2>

      <div
        className="add"
        onClick={() => {
          _data.slider.push({ file: null, status: "updated" });
          updateData();
        }}
      >
        <img src={icons} className="image-add" />
      </div>

      <main style={{ display: "flex", flexWrap: "wrap" }}>
        {data?.slider?.length > 0 &&
          data?.slider?.map((item, index) => (
            <MediaPicker
              onChange={(file, image) => {
                _data.slider[index] = { file, image, status: "updated" };
                updateData();
              }}
              source={data.slider[index].image}
              Delete
              onDelete={() => {
                const newData = _data.slider.filter(
                  (item) => _data.slider.indexOf(item) !== index
                );
                _data.slider = newData;
                updateData();
              }}
            />
          ))}
      </main>
      <button className="save btn" onClick={handleSave}>
        Save
      </button>
    </div>
  );
};

export default DescImages;
